import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'

export class DetallesLineaDialogView extends Component {
  render () {
    const { linea } = this.props
    const cereales = linea.cereales
    const cerealesJsx = []
    cerealesJsx.push(
      <Row>
        <Col md={4}>
          <span style={{ fontWeight: 'bold', fontSize: 'large' }}>Cereal: </span>
        </Col>
        <Col md={4}>
          <span style={{ fontWeight: 'bold', fontSize: 'large' }}>Variedad: </span>
        </Col>
        <Col md={4}>
          <span style={{ fontWeight: 'bold', fontSize: 'large' }}>Total [tn]: </span>
        </Col>
      </Row>)
    cereales.forEach(cereal => {
      cerealesJsx.push(
        <Row>
          <Col md={4}>
            {cereal.cereal}
          </Col>
          <Col md={4}>
            {cereal.variedad && cereal.variedad.trim() !== 'UNDEF' ? cereal.variedad.trim() : 'Indefinido'}
          </Col>
          <Col md={4}>
            {cereal.cantidad}
          </Col>
        </Row>)
    })
    return (
      <div>
        <Row>
          <Col md={12}>
            <h2>Detalles de linea {linea.linea}</h2>
          </Col>
        </Row>
        {cerealesJsx}
      </div>
    )
  }
}
